import * as React from "react"
import { memo } from "react"
const SvgComponent = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={230}
        height={174}
        fill="none"
        {...props}
    >
        <g clipPath="url(#a)">
            <path
                fill="#262626"
                d="m213.273 154.38 3.018 19.226h-20.754l3.719-19.226h14.017Z"
            />
            <path
                fill="#fff"
                d="m213.273 154.38 3.018 19.226h-20.754l3.719-19.226h14.017Z"
                opacity={0.2}
            />
            <path
                fill="#494949"
                d="M206.442 154.441a.199.199 0 0 1-.194-.232l5.716-34.966a.196.196 0 0 1 .226-.164.2.2 0 0 1 .162.229l-5.716 34.966a.198.198 0 0 1-.194.167Z"
            />
            <path
                fill="#494949"
                d="M207.789 146.516a.196.196 0 0 1-.18-.119.2.2 0 0 1 .102-.262l13.955-6.186c.1-.045.215.002.259.102a.2.2 0 0 1-.102.262l-13.955 6.186a.188.188 0 0 1-.079.017ZM208.481 140.529a.217.217 0 0 1-.073-.033l-9.414-6.818a.201.201 0 0 1-.046-.278.195.195 0 0 1 .274-.046l9.414 6.818a.2.2 0 0 1 .046.278.196.196 0 0 1-.201.079Z"
            />
            <path
                fill="#0CBC8B"
                d="M225.724 151.056c4.079-2.051 5.485-7.597 3.142-12.389-2.344-4.791-7.55-7.014-11.629-4.963-4.078 2.05-5.485 7.597-3.141 12.388 2.343 4.792 7.549 7.014 11.628 4.964Z"
            />
            <path
                fill="#fff"
                d="M226.747 149.669c-4.078 2.051-9.285-.172-11.628-4.963-1.589-3.249-1.454-6.846.071-9.464a7.17 7.17 0 0 1 2.048-1.541c4.078-2.05 9.285.172 11.628 4.963 1.59 3.252 1.455 6.848-.072 9.465a7.167 7.167 0 0 1-2.047 1.54Z"
                opacity={0.5}
            />
            <path
                fill="#0CBC8B"
                d="M220.302 123.034c1.692-4.251-.494-9.153-4.883-10.948-4.389-1.796-9.318.195-11.011 4.446-1.692 4.251.495 9.153 4.883 10.948 4.389 1.796 9.319-.195 11.011-4.446Z"
            />
            <path
                fill="#fff"
                d="M220.301 123.033c-.064.16-.133.317-.207.471-2.167 3.099-6.349 4.361-10.13 2.814-4.389-1.795-6.575-6.697-4.883-10.948a7.4 7.4 0 0 1 .207-.472c2.167-3.098 6.349-4.361 10.13-2.814 4.389 1.795 6.575 6.697 4.883 10.949Z"
                opacity={0.5}
            />
            <path
                fill="#0CBC8B"
                d="M203.742 136.43c2.205-4.123 1.147-9.029-2.363-10.958-3.51-1.929-8.142-.15-10.347 3.973-2.205 4.124-1.146 9.03 2.363 10.959 3.51 1.929 8.143.15 10.347-3.974Z"
            />
            <path
                fill="#fff"
                d="M192.543 139.158c3.509 1.928 8.142.149 10.347-3.974 1.495-2.796 1.489-5.952.235-8.297a6.325 6.325 0 0 0-1.746-1.416c-3.51-1.929-8.142-.149-10.347 3.974-1.496 2.798-1.49 5.954-.235 8.297a6.31 6.31 0 0 0 1.746 1.416Z"
                opacity={0.5}
            />
            <path
                fill="#F4F4F4"
                d="M87.985 20.213c1.156-3.42.309-6.814-1.892-7.578-2.2-.764-4.921 1.39-6.077 4.812-1.155 3.421-.308 6.814 1.892 7.578 2.201.764 4.922-1.39 6.077-4.811Z"
            />
            <path
                fill="#F4F4F4"
                d="M80.15 17.438c1.567-.716 1.962-3.265.882-5.694-1.08-2.428-3.225-3.817-4.793-3.1-1.567.716-1.962 3.265-.882 5.694s3.226 3.817 4.793 3.1ZM77.185 23.083h8.384c1.534 0 2.78 1.263 2.78 2.818v3.867c0 1.556-1.246 2.819-2.78 2.819h-8.384v-9.504Z"
            />
            <path
                fill="#292A2E"
                d="M77.185 23.083h8.384c1.534 0 2.78 1.263 2.78 2.818v3.867c0 1.556-1.246 2.819-2.78 2.819h-8.384v-9.504Z"
                opacity={0.05}
            />
            <g fill="#292A2E" opacity={0.05}>
                <path d="M87.278 16.521h-.01a.104.104 0 0 1-.081-.055c-.043-.083-.022-.173-.006-.24a1.1 1.1 0 0 0-.035-.618.106.106 0 0 1 .06-.135.103.103 0 0 1 .134.061c.067.183.09.393.068.593a1.82 1.82 0 0 1 .399-.28.103.103 0 0 1 .139.047.105.105 0 0 1-.046.14 1.718 1.718 0 0 0-.542.45.104.104 0 0 1-.08.037ZM84.143 14.025a.101.101 0 0 1-.04-.008c-.084-.035-.123-.12-.152-.18a1.039 1.039 0 0 0-.406-.453.106.106 0 0 1-.038-.144.103.103 0 0 1 .141-.038c.164.095.31.24.416.408.026-.17.071-.332.135-.48a.104.104 0 0 1 .136-.053.106.106 0 0 1 .054.138c-.091.21-.14.454-.143.706a.105.105 0 0 1-.103.104ZM81.5 17.406a.105.105 0 0 1-.04-.008c-.084-.035-.123-.118-.152-.179a1.044 1.044 0 0 0-.406-.454.106.106 0 0 1-.039-.143.103.103 0 0 1 .142-.039c.164.096.31.24.416.409.025-.17.07-.332.134-.48a.103.103 0 0 1 .136-.054.105.105 0 0 1 .054.138c-.09.21-.14.455-.142.706a.104.104 0 0 1-.104.104ZM84.306 16.895a.106.106 0 0 1-.04-.008c-.084-.035-.124-.119-.152-.18a1.044 1.044 0 0 0-.406-.453.106.106 0 0 1-.038-.144.103.103 0 0 1 .141-.038c.164.095.31.24.416.409.025-.17.071-.332.135-.48a.103.103 0 0 1 .136-.054.105.105 0 0 1 .053.138c-.09.21-.14.454-.142.706a.104.104 0 0 1-.103.104ZM86.09 19.851a.104.104 0 0 1-.102-.092c-.011-.093.04-.169.078-.224.118-.173.185-.387.186-.59 0-.057.047-.104.104-.104.058 0 .104.048.103.106a1.306 1.306 0 0 1-.147.58 1.78 1.78 0 0 1 .472-.108.105.105 0 0 1 .018.208c-.22.02-.45.092-.662.21a.099.099 0 0 1-.05.014ZM81.736 21.672a.104.104 0 0 1-.043-.009c-.083-.038-.12-.123-.147-.185a1.044 1.044 0 0 0-.392-.466.106.106 0 0 1-.033-.144.103.103 0 0 1 .142-.034c.16.1.303.25.403.422.03-.169.081-.33.15-.476a.103.103 0 0 1 .137-.05.106.106 0 0 1 .05.14c-.098.208-.154.45-.164.702a.105.105 0 0 1-.049.085.102.102 0 0 1-.054.015ZM84.327 22.646h-.01a.104.104 0 0 1-.082-.056c-.042-.082-.021-.172-.006-.237a1.102 1.102 0 0 0-.034-.62.105.105 0 0 1 .06-.136.103.103 0 0 1 .133.062c.068.183.092.392.069.593.124-.114.258-.208.399-.28a.103.103 0 0 1 .138.047.105.105 0 0 1-.046.14 1.722 1.722 0 0 0-.541.449.103.103 0 0 1-.08.038Z" />
            </g>
            <g fill="#292A2E" opacity={0.05}>
                <path d="M79.682 12.641h-.01a.104.104 0 0 1-.081-.055c-.043-.083-.022-.173-.006-.239a1.1 1.1 0 0 0-.035-.62.106.106 0 0 1 .061-.134.104.104 0 0 1 .133.061c.068.183.091.393.068.593a1.82 1.82 0 0 1 .4-.28.103.103 0 0 1 .138.047.106.106 0 0 1-.046.14 1.72 1.72 0 0 0-.542.45.104.104 0 0 1-.08.037ZM77.508 10.294a.103.103 0 0 1-.039-.008c-.084-.035-.124-.118-.152-.18a1.045 1.045 0 0 0-.406-.453.106.106 0 0 1-.038-.143.103.103 0 0 1 .141-.04c.164.097.31.241.416.41.025-.17.07-.332.134-.48a.103.103 0 0 1 .137-.054.105.105 0 0 1 .053.138c-.09.21-.14.455-.142.706a.104.104 0 0 1-.104.104ZM77.16 12.791a.104.104 0 0 1-.04-.008c-.084-.035-.124-.119-.152-.18a1.04 1.04 0 0 0-.406-.453.106.106 0 0 1-.038-.143.103.103 0 0 1 .141-.039c.164.096.31.24.416.409.026-.17.071-.332.135-.48a.103.103 0 0 1 .136-.054.105.105 0 0 1 .053.138c-.09.21-.14.455-.142.706a.105.105 0 0 1-.103.104ZM78.945 15.747a.104.104 0 0 1-.103-.093c-.011-.092.04-.168.078-.223.118-.173.185-.387.186-.59.001-.057.047-.103.104-.103.058 0 .104.048.103.106a1.307 1.307 0 0 1-.147.58 1.77 1.77 0 0 1 .472-.11.107.107 0 0 1 .112.097.104.104 0 0 1-.095.113c-.22.018-.448.091-.66.21a.1.1 0 0 1-.05.013ZM76.782 15.096c-.082 0-.147-.05-.196-.088a.99.99 0 0 0-.56-.206.104.104 0 0 1-.1-.109c.001-.057.049-.105.106-.101.189.006.384.065.553.164a1.967 1.967 0 0 1-.095-.495.104.104 0 0 1 .098-.11c.063-.005.106.04.109.099.013.23.078.47.188.694a.106.106 0 0 1-.002.097.103.103 0 0 1-.08.054.187.187 0 0 1-.021.001Z" />
            </g>
            <path fill="#F4F4F4" d="M48.718 32.373h23.063v-6.71H48.718v6.71Z" />
            <path
                fill="#292A2E"
                d="M48.718 32.373h23.063v-6.71H48.718v6.71Z"
                opacity={0.05}
            />
            <path
                fill="#fff"
                d="M51.815 32.373h3.023v-6.71h-3.023v6.71ZM56.269 30.915h12.565v-3.976H56.27v3.976Z"
            />
            <path fill="#F4F4F4" d="M43.22 25.67h22.746v-6.71H43.219v6.71Z" />
            <path
                fill="#292A2E"
                d="M59.93 25.67h2.98v-6.71h-2.98v6.71Z"
                opacity={0.05}
            />
            <path fill="#fff" d="M46.126 24.211h12.393v-3.976H46.126v3.976Z" />
            <path
                fill="#F4F4F4"
                d="m32.113 32.373 14.984-17.775-5.032-4.36-14.983 17.776 5.031 4.36Z"
            />
            <path
                fill="#292A2E"
                d="m34.125 29.986 1.964-2.33-5.032-4.358-1.963 2.329 5.031 4.36ZM35.925 25.606l8.164-9.684-2.982-2.584-8.163 9.685 2.981 2.583Z"
                opacity={0.05}
            />
            <path
                fill="#F4F4F4"
                d="M90.752 32.25H24.16v2.654h66.59V32.25ZM209.93 0h-83.781v84.94h83.781V0Z"
            />
            <path fill="#F4F4F4" d="M210.89 0h-.96v84.94h.96V0Z" />
            <path
                fill="#292A2E"
                d="M210.89 0h-.96v84.94h.96V0ZM189.633 58.531V36.308h-17.955v12.911h-27.813V72.08h-11.821v12.86H205.9V58.532h-16.267Z"
                opacity={0.05}
            />
            <path
                fill="#FFFFFA"
                d="M187.058 38.72h-13.075v2.414h13.075V38.72ZM187.058 43.721h-13.075v2.413h13.075v-2.413ZM187.058 48.721h-13.075v2.413h13.075v-2.413ZM203.581 60.873h-2.41v2.413h2.41v-2.413ZM203.581 65.874h-2.41v2.413h2.41v-2.413ZM203.581 70.874h-2.41v2.413h2.41v-2.413ZM199.123 60.873h-2.41v2.413h2.41v-2.413ZM199.123 65.874h-2.41v2.413h2.41v-2.413ZM199.123 70.874h-2.41v2.413h2.41v-2.413ZM194.785 60.873h-2.41v2.413h2.41v-2.413ZM194.785 65.874h-2.41v2.413h2.41v-2.413ZM194.785 70.874h-2.41v2.413h2.41v-2.413Z"
                opacity={0.34}
            />
            <path
                fill="#fff"
                d="M209.93 41.994h-16.858V0h-1.394v41.994h-45.536V0h-1.394v41.994h-18.599v1.413h18.599v41.534h1.394V43.407h45.536v41.534h1.394V43.407h16.858v-1.413Z"
            />
            <path fill="#F4F4F4" d="M213.267 84.838h-90.455v2.825h90.455v-2.825Z" />
            <path
                fill="#292A2E"
                d="M213.267 84.838h-90.455v2.825h90.455v-2.825ZM214.573 84.838h-1.306v2.825h1.306v-2.825Z"
                opacity={0.1}
            />
            <path
                fill="#292A2E"
                d="M214.573 84.838h-1.306v2.825h1.306v-2.825Z"
                opacity={0.1}
            />
            <path
                fill="#262626"
                d="M174.842 137.85h-142.3c-3.675 0-6.654 3.02-6.654 6.746v4.156c0 3.726 2.979 6.746 6.654 6.746h8.048l-4.3 18.315h4.149l6.593-18.315h113.279l6.45 18.315h4.332l-4.299-18.315h8.048c3.675 0 6.654-3.02 6.654-6.746v-4.156c0-3.726-2.979-6.746-6.654-6.746Z"
            />
            <path
                fill="#fff"
                d="M174.842 137.85h-142.3c-3.675 0-6.654 3.02-6.654 6.746v4.156c0 3.725 2.979 6.746 6.654 6.746h8.048l-4.3 18.315h4.149l6.593-18.315h113.279l6.45 18.315h4.333l-4.3-18.315h8.048c3.675 0 6.654-3.02 6.654-6.746v-4.156c0-3.725-2.979-6.746-6.654-6.746Z"
                opacity={0.2}
            />
            <path
                fill="#0F5FCB"
                d="M38.051 58.733h131.281c10.844 0 19.647 8.925 19.647 19.919v52.065c0 3.969-3.178 7.19-7.092 7.19H25.497c-3.915 0-7.092-3.221-7.092-7.19V78.652c0-10.994 8.803-19.919 19.646-19.919Z"
            />
            <path
                fill="#fff"
                d="M38.051 58.733h131.281c10.844 0 19.647 8.925 19.647 19.919v52.065c0 3.969-3.178 7.19-7.092 7.19H25.497c-3.915 0-7.092-3.221-7.092-7.19V78.652c0-10.994 8.803-19.919 19.646-19.919Z"
                opacity={0.74}
            />
            <path
                fill="#0F5FCB"
                d="M200.376 83.415c-5.289-1.705-10.94 1.26-12.622 6.623L174.371 127.1H33.012L19.63 90.038c-1.681-5.363-7.333-8.328-12.622-6.623C1.717 85.12-1.207 90.85.475 96.212l15.61 44.165c1.326 4.229 5.2 7.101 9.577 7.101h156.059c4.377 0 8.251-2.872 9.577-7.101l15.61-44.165c1.682-5.362-1.243-11.092-6.532-12.797Z"
            />
            <path
                fill="#fff"
                d="M200.376 83.415c-5.289-1.705-10.94 1.26-12.622 6.623L174.371 127.1H33.012L19.63 90.038c-1.681-5.363-7.333-8.328-12.622-6.623C1.717 85.12-1.207 90.85.475 96.212l15.61 44.165c1.326 4.229 5.2 7.101 9.577 7.101h156.059c4.377 0 8.251-2.872 9.577-7.101l15.61-44.165c1.682-5.362-1.243-11.092-6.532-12.797Z"
                opacity={0.87}
            />
            <path
                fill="#292A2E"
                d="M225.991 174H4.137a.186.186 0 0 1-.185-.187c0-.103.083-.187.185-.187H225.99c.102 0 .185.084.185.187a.186.186 0 0 1-.185.187Z"
            />
            <path
                fill="#292A2E"
                d="M225.991 174H4.137a.186.186 0 0 1-.185-.187c0-.103.083-.187.185-.187H225.99c.102 0 .185.084.185.187a.186.186 0 0 1-.185.187Z"
                opacity={0.65}
            />
            <path
                fill="#262626"
                d="m149.495 111.074-39.418-29.12c-3.212-2.409-7.644-2.878-11.389-.82l-.747.41-46.511 24.018 13.809 21.228 38.51-25.652 36.331 23.749 9.415-13.813Z"
            />
            <path
                fill="#0A0A0A"
                d="m149.495 111.074-39.418-29.12c-3.212-2.409-7.644-2.878-11.389-.82l-.747.41-46.511 24.018 13.809 21.228 38.51-25.652 36.331 23.749 9.415-13.813Z"
                opacity={0.8}
            />
            <path
                fill="#0C0C0C"
                d="M24.947 83.812a.092.092 0 0 1-.096-.043.094.094 0 0 1 .03-.129l4.573-2.822a.092.092 0 0 1 .127.031.094.094 0 0 1-.03.129L24.977 83.8a.093.093 0 0 1-.03.012Z"
            />
            <path
                fill="#0F5FCB"
                d="M157.526 114.704s6.281-.366 7.39-6.131c1.109-5.766 5.51-3.886 5.51-3.886l-2.935 22.211-10.945-1.487.98-10.707Z"
            />
            <path
                fill="#262626"
                d="m58.681 100.73-29.392 2.206s-1.376 5.712.67 12.198c1.696 5.375 5.625 11.607 14.653 11.78h114.405l.761-15.222L58.681 100.73Z"
            />
            <path
                fill="#0C0C0C"
                d="M47.168 36.056s2.074-2.861 1.346-7.78c-.563-3.81-3.189-.435-3.189-.435s-.431-2.739-2.246-1.904c-1.816.835-2.06 3.924-2.06 3.924M33.385 29.211s-9.09 3.867-1.89 15.741l.847-.195 1.72-.397"
            />
            <path
                fill="#FF9E85"
                d="M49.862 55.575c-.043.001.704 8.026-8.512 8.77-6.38.516-9.67-5.913-9.814-5.89.658-.254 1.464-.609 1.786-.738 1.07-.428 2.313-1.575 2.333-3.58.012-1.157-1.186-6.872-1.265-8.027l10.016.663c.235 2.43.145 8.16 3.614 8.625.578.077 1.195.133 1.842.177Z"
            />
            <path
                fill="#0C0C0C"
                d="M45.57 53.448c-.205-.422-.346-.795-.525-1.477-.32-1.22-.426-2.371-.48-3.553a10.628 10.628 0 0 1-5.715-1.532c-.076.701-.613 3.798-.242 4.394.704 1.128 3.439 2.724 6.963 2.168Z"
                opacity={0.22}
            />
            <path
                fill="#FF9E85"
                d="M43.767 51.358c-3.803.786-8.934-.243-10.5-5.32l-1.414-4.58c-1.567-5.077-.207-10.027 4.508-11.523 4.715-1.495 9.509 1.503 11.075 6.58l.626 2.027c.129.418.317 1.18.466 2.135.297 1.905.742 4.804.071 7.059-.633 2.129-2.403 3.12-4.832 3.622Z"
            />
            <path
                fill="#0A0A0A"
                d="M46.322 40.934a.545.545 0 0 0 .45-.623.54.54 0 0 0-.615-.456.545.545 0 0 0-.45.623.54.54 0 0 0 .615.456ZM43.458 44.352a.219.219 0 0 1-.088-.427l1.11-.298-1.045-2.174a.22.22 0 0 1 .1-.292.215.215 0 0 1 .288.101l1.159 2.413a.222.222 0 0 1 .002.187.216.216 0 0 1-.141.12l-1.363.365a.202.202 0 0 1-.022.005ZM43.583 46.836c-1.93.304-2.686-.788-2.72-.84a.22.22 0 0 1 .057-.303.214.214 0 0 1 .299.058c.032.046.8 1.114 2.883.522a.213.213 0 0 1 .266.151.219.219 0 0 1-.15.27c-.224.063-.436.11-.635.141ZM40.653 38.493c.075.152-.465.484-1.242.832-.777.348-1.487.623-1.573.43-.11-.246.402-.945 1.18-1.293.777-.348 1.515-.21 1.635.03ZM41.038 42.12a.545.545 0 0 0 .45-.623.54.54 0 0 0-.616-.456.545.545 0 0 0-.45.623.54.54 0 0 0 .616.456ZM47.135 37.586c.008.17-.618.251-1.468.25-.85-.002-1.609-.043-1.61-.255-.002-.27.656-.702 1.506-.7.85 0 1.559.436 1.572.705Z"
            />
            <path
                fill="#FF9E85"
                d="M34.036 47.492c-1.432.454-3.073-.731-3.522-2.184-.448-1.452.466-2.622 1.9-3.076l1.038.739 1.817 4.13-1.232.391Z"
            />
            <path
                fill="#0C0C0C"
                d="M34.326 44.808a.462.462 0 0 0 .358-.543c-.317-1.614-1.245-7.073.477-8.007 1.35-.732 5.441.278 8.484-1.324 1.33-.7 2.775-.752 3.11-.118.134.252-.121-3.861-3.192-6.11-2.446-1.791-8.398-.701-10.794.855-6.632 4.309-.559 13.078-.559 13.078l.907 2.05a.455.455 0 0 0 .508.264l.701-.145Z"
            />
            <path
                fill="#0C0C0C"
                d="M41.832 31.955c.998-.548 1.162-2.2.366-3.69-.796-1.489-2.25-2.252-3.248-1.704-.998.549-1.162 2.2-.366 3.69.795 1.49 2.25 2.252 3.248 1.704Z"
            />
            <path
                fill="#0F5FCB"
                d="M63.831 70.61c.367 3.48 2.408 25.241 2.937 29.513l-37.45 7.35c-.942-3.761-5.084-20.204-7.32-27.482-2.135-6.945-3.844-9.96-3.368-12.342.84-4.201 5.544-6.927 8.866-8.065 2.028-.694 5.12-1.514 5.12-1.514s1.305 5.388 7.686 4.449c8.688-1.278 6.938-7.319 6.98-7.327 1.395-.274 9.183-.736 11.32.146 3.02 1.245 4.273 3.504 4.728 5.716.524 2.547.086 5.608.501 9.555Z"
            />
            <path
                fill="#FF9E85"
                d="M90.542 49.666a.993.993 0 0 0-1.508.353l.575-1.178c.24-.492.092-1.115-.38-1.383a.993.993 0 0 0-1.386.433l.26-.533c.214-.439.118-.989-.267-1.285a.993.993 0 0 0-1.508.353l-.456.934a1.02 1.02 0 0 0-.452-1.358c-.507-.297-1.09.134-1.32.607l-2.151 4.22.062-1.366c.026-.548-.356-1.058-.895-1.112a1.004 1.004 0 0 0-1.099.96l-.493 10.732 3.219.245a5.021 5.021 0 0 0 4.888-2.825l3.178-6.512c.214-.44.118-.989-.267-1.285Z"
            />
            <path
                fill="#FF9E85"
                d="M83.84 51.332c.045.023.1.004.122-.041l2.04-4.016a.094.094 0 0 0-.039-.127c-.04-.025-.101-.005-.124.04l-2.04 4.017a.094.094 0 0 0 .039.126l.002.001ZM85.562 52.294c.045.022.1.004.123-.042l2.277-4.482a.094.094 0 0 0-.04-.126.095.095 0 0 0-.124.04l-2.277 4.482a.094.094 0 0 0 .04.126l.001.002ZM87.422 53.346c.045.022.1.004.122-.042l1.817-3.575a.094.094 0 0 0-.04-.126.092.092 0 0 0-.124.04l-1.817 3.575a.094.094 0 0 0 .04.126l.002.002Z"
            />
            <path
                fill="#0C0C0C"
                d="M83.84 51.332c.045.023.1.004.122-.041l2.04-4.016a.094.094 0 0 0-.039-.127c-.04-.025-.101-.005-.124.04l-2.04 4.017a.094.094 0 0 0 .039.126l.002.001ZM85.562 52.294c.045.022.1.004.123-.042l2.277-4.482a.094.094 0 0 0-.04-.126.095.095 0 0 0-.124.04l-2.277 4.482a.094.094 0 0 0 .04.126l.001.002ZM87.422 53.346c.045.022.1.004.122-.042l1.817-3.575a.094.094 0 0 0-.04-.126.092.092 0 0 0-.124.04l-1.817 3.575a.094.094 0 0 0 .04.126l.002.002Z"
                opacity={0.1}
            />
            <path
                fill="#0F5FCB"
                d="m77.85 54.861-4.355 16.731-11.612-13.838-10.79 8.77 20.315 24.211.098.124a6.802 6.802 0 0 0 3.877 2.433c3.693.817 7.338-1.557 8.143-5.3l6.485-30.161-12.161-2.97Z"
            />
            <path
                fill="#0C0C0C"
                d="M65.007 86.737a.093.093 0 0 1-.11-.09l-.156-11.389c0-.051.04-.094.09-.094.052-.001.093.04.094.092l.157 11.387a.093.093 0 0 1-.075.094Z"
            />
            <path
                fill="snow"
                d="m67.57 68.384-9.773.122.148 12.15 9.772-.122-.148-12.15Z"
            />
            <path
                fill="snow"
                d="M57.917 78.463c-2.11.026-3.848-1.694-3.874-3.833-.026-2.14 1.67-3.902 3.78-3.929 2.11-.026 3.849 1.693 3.875 3.833.026 2.14-1.67 3.902-3.78 3.928Zm-.078-6.453c-1.399.017-2.523 1.185-2.506 2.604.017 1.418 1.17 2.557 2.569 2.54 1.398-.017 2.522-1.185 2.505-2.604-.017-1.418-1.17-2.558-2.568-2.54ZM64.53 65.498a.184.184 0 0 1-.163-.094.189.189 0 0 1 .069-.255c.886-.51.972-1.89.544-2.931-.194-.472-.466-.924-.728-1.36-.336-.56-.684-1.14-.888-1.783-.479-1.51-.056-3.278 1.053-4.399a.183.183 0 0 1 .261.001.189.189 0 0 1 0 .265c-1.014 1.023-1.4 2.639-.963 4.02.19.6.512 1.135.852 1.701.27.45.548.914.753 1.41.484 1.175.402 2.766-.702 3.401a.182.182 0 0 1-.088.025ZM60.724 61.84a.184.184 0 0 1-.165-.1c-.543-1.041-1.219-2.338-1.161-3.7.045-1.084.537-2.056 1.012-2.997.292-.578.594-1.177.786-1.79a.184.184 0 0 1 .231-.122c.097.032.15.137.12.235-.2.643-.51 1.255-.81 1.848-.477.946-.929 1.84-.971 2.841-.053 1.261.57 2.456 1.119 3.51a.188.188 0 0 1-.077.253.177.177 0 0 1-.084.022Z"
            />
            <path
                fill="#FF9E85"
                d="M58.487 78.257a.976.976 0 0 0-1.463-.416l1.042-.74c.436-.31.598-.917.316-1.373a.974.974 0 0 0-1.396-.29l.472-.334c.389-.276.561-.796.367-1.235a.976.976 0 0 0-1.463-.416l-.827.586c.444-.315.552-.935.241-1.385-.298-.499-1-.406-1.42-.108l-1.698 1.117.447-.682c.277-.46.185-1.082-.254-1.386a.974.974 0 0 0-1.393.303l-5.17 8.544 2.66 1.749a4.886 4.886 0 0 0 5.524-.1l3.648-2.6c.389-.276.56-.795.367-1.234Z"
            />
            <path
                fill="#FF9E85"
                d="M54.502 74.786a.091.091 0 0 1-.095-.042.094.094 0 0 1 .028-.129l1.152-.742a.092.092 0 0 1 .127.029.094.094 0 0 1-.028.129l-1.152.742a.09.09 0 0 1-.032.013ZM55.54 76.437a.091.091 0 0 1-.095-.041.094.094 0 0 1 .027-.13l1.572-1.03a.092.092 0 0 1 .128.028.094.094 0 0 1-.028.13l-1.572 1.03a.087.087 0 0 1-.033.013ZM56.653 78.231a.092.092 0 0 1-.096-.042.094.094 0 0 1 .03-.129l.754-.469a.092.092 0 0 1 .127.031.094.094 0 0 1-.03.129l-.755.468a.09.09 0 0 1-.03.013Z"
            />
            <path
                fill="#0C0C0C"
                d="M54.502 74.786a.091.091 0 0 1-.095-.042.094.094 0 0 1 .028-.129l1.152-.742a.092.092 0 0 1 .127.029.094.094 0 0 1-.028.129l-1.152.742a.09.09 0 0 1-.032.013ZM55.54 76.437a.091.091 0 0 1-.095-.041.094.094 0 0 1 .027-.13l1.572-1.03a.092.092 0 0 1 .128.028.094.094 0 0 1-.028.13l-1.572 1.03a.087.087 0 0 1-.033.013ZM56.653 78.231a.092.092 0 0 1-.096-.042.094.094 0 0 1 .03-.129l.754-.469a.092.092 0 0 1 .127.031.094.094 0 0 1-.03.129l-.755.468a.09.09 0 0 1-.03.013Z"
                opacity={0.17}
            />
            <path
                fill="#0F5FCB"
                d="M21.682 107.17c-1.73.34-3.56.003-5.092-1.01-2.3-1.519-3.495-4.274-3.046-7.02l4.944-30.22c.625-3.819 4.185-6.402 7.953-5.768 3.767.633 6.315 4.243 5.69 8.063l-2.364 14.451 18.19-11.875 7.262 11.564-31.065 20.798a6.862 6.862 0 0 1-2.472 1.017Z"
            />
            <path
                fill="#0C0C0C"
                d="M28.05 103.649a.09.09 0 0 1-.094-.04.094.094 0 0 1 .026-.129l27.11-18.152-7.244-11.356L29.55 85.591a.09.09 0 0 1-.1-.002.094.094 0 0 1-.04-.094l1.538-8.557a.092.092 0 0 1 .108-.075c.05.01.083.058.074.109l-1.5 8.348 18.196-11.555a.092.092 0 0 1 .126.028l7.343 11.511c.028.043.016.1-.027.129l-27.185 18.203a.084.084 0 0 1-.033.013ZM72.456 78.713a.093.093 0 0 1-.109-.106l1.173-7.717a.092.092 0 1 1 .182.028l-1.173 7.717a.093.093 0 0 1-.073.078Z"
            />
            <path
                fill="#FF9E85"
                d="m80.359 50.944.068-1.87c.025-.548-.357-1.058-.896-1.113a1.004 1.004 0 0 0-1.098.961l-.177 3.836"
            />
            <path
                fill="#0CBC8B"
                d="m87.084 53.293-4.962-4.298 2.714-19.658 5.614 4.682-3.366 19.274Z"
            />
            <path
                fill="#0CBC8B"
                d="m84.434 33.7.66-3.784s.732 2.884 4.588 4.406l-.138 3.095-5.286-1.96.176-1.758Z"
            />
            <path
                fill="#fff"
                d="m84.434 33.7.66-3.784s.732 2.884 4.588 4.406l-.138 3.095-5.286-1.96.176-1.758Z"
                opacity={0.49}
            />
            <path
                fill="#0CBC8B"
                d="M88.782 34.675s-6.707-2.85-12.064-1.721l11.625 2.578.44-.856Z"
            />
            <path
                fill="#fff"
                d="M88.782 34.675s-6.707-2.85-12.064-1.721l11.625 2.578.44-.856Z"
                opacity={0.81}
            />
            <path
                fill="#0CBC8B"
                d="m90.45 34.02-1.983.78-3.227 19.073 1.844-.58 3.365-19.274Z"
            />
            <path
                fill="#fff"
                d="m90.45 34.02-1.983.78-3.227 19.073 1.844-.58 3.365-19.274Z"
                opacity={0.25}
            />
            <path
                fill="#0CBC8B"
                d="m76.067 32.494 12.4 2.306-3.227 19.073-12.14-2.122 2.967-19.257Z"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h230v174H0z" />
            </clipPath>
        </defs>
    </svg>
)
const Users = memo(SvgComponent)
export default Users
